import { Injectable } from "@angular/core";
import { ToastController } from "@ionic/angular";

@Injectable({
    providedIn: 'root'
})
export class ToastService {

    constructor(private toastController: ToastController) { }

    /**
     * Method to present a toast with a message.
     * @param message: string containing the message to be shown in the toast.
     */
    async presentToast(message?: string, position?: any, duration?: number, header?: string, color?: string, icon?: string) {
        const toast = await this.toastController.create({
            message: message,
            duration: duration,
            header: header,
            color: color,
            position: position,
            cssClass: 'custom-toast',
            icon: icon
        });

        await toast.present();
    }

}